<div class="card primary">
    <div [title]="'Domain ' + domain?.Value + ': ' + domain?.Label" class="card-header text-center text-white bg-primary">
        <span>Domain {{domain?.Value}}</span>
        <h5 class="m-0" [ngClass]="getTitleSizeClass(domain?.Label)">{{domain?.Label}}</h5>
    </div>
    <div class="card-body">
        <ul>
            <li *ngFor="let subdomain of domain?.Subdomains ?? []">
                <ng-template
                    [ngTemplateOutlet]="itemTemplate"
                    [ngTemplateOutletContext]="{ 
                        $implicit: {
                            domain: domain?.Value, 
                            subdomain: subdomain 
                        } 
                    }">
                </ng-template>
            </li>
        </ul>
    </div>
</div>
